import { print } from 'graphql';
import { v4 as uuidv4 } from 'uuid';

import { ACTIVITY_CREATE } from 'src/api/graphql/mutations/activity.gql';
import { graphqlUpload } from 'src/utils/helpers/graphqlUpload';
import { createGraphqlRequestError } from 'src/utils/helpers/getGraphqlErrorMessage';

export const createActivity = async (input) => {
	const idempotencyKey = uuidv4();
	const result = await graphqlUpload({
		query: print(ACTIVITY_CREATE),
		variables: { idempotencyKey, input },
	});

	if (result.errors?.length) {
		throw createGraphqlRequestError(
			result.errors,
			'Не удалось создать событие',
		);
	}

	return result.data.ActivityCreate.activity;
};
